module.exports = __webpack_public_path__ + "static/img/popup.77c269d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/popup.png
// module id = l84S
// module chunks = 0